import React, { useState, useEffect } from "react";
import ReactWOW from "react-wow";
import CustomCountdown from "@/modules/Countdown";
import { $t } from "@/modules/i18n";

const Banner = ({ message }) => {
  const [loading, setLoading] = useState(true);

  function preloadImg(srcArr) {
    let count = 0;
    if(srcArr instanceof Array){
      for(var i=0; i<srcArr.length; i++){
          var oImg = new Image();
          oImg.src = srcArr[i];
          oImg.onload = function() {
            count++;
            if(count >= 2) {
              setLoading(false);
            }
          }
      }
    }
  }

  useEffect(() => {
    const srcArr = [require('@tc/assets/icons/banner-mobile-title.svg'), require('@tc/assets/icons/logo.svg')]
    preloadImg(srcArr);
  }, [])

  return (
    <section className="top-banner">
      {loading ? null : (
        <div className="content">
          <div className="logo">
            <img src={require('@tc/assets/icons/logo.svg')}/>
          </div>
          <div className="title">
            <img src={require('@tc/assets/icons/banner-mobile-title.svg')} />
          </div>
          {/* <div className="title">{$t(message.title)}</div> */}
          {/* <div className="subtitle">
              {$t(message.sutTitle)}
            </div> */}
          <div className="time">
            <span className="deco left" />
            {$t(message.time)}
            <span className="deco right" />
          </div>
          <p className="desc">{$t(message.desc)}</p>
          <CustomCountdown endDate={new Date("2021/09/25 00:00")} />
          <a
            className="register"
            href="https://bit.ly/3Avg4zt"
            target="_blank"
            rel="noopener noreferrer"
          >
            {$t(message.register)}
          </a>
        </div>
      )}
      
    </section>
  );
}

export default Banner;
